<shrd-uic-smartbar [isFixed]="false" [containerClasses]="!inModal ? 'pe-md-1' : ''" [isLight]="true">
  <div class="smartbar-column-left d-md-none">
    <div class="content-box content-box-tertiary-left">
      <button (click)="goBackAction.emit()" shrdUicButton variant="tertiaryMinorBorderless">
        <shrd-uic-svg-icon icon="arrow-left"></shrd-uic-svg-icon>
      </button>
    </div>
  </div>
  <div *ngIf="hasAction" class="smartbar-column-right mw-50 pe-md-3">
    <div class="content-box">
      <a
        *ngIf="actionUrl; else buttonTpl"
        class="btn btn-primary m-0"
        shrdUicButton
        variant="primary"
        [href]="actionUrl"
        (click)="onSubmitClick()"
      >
        <ng-container *ngTemplateOutlet="labelTpl"></ng-container>
      </a>
    </div>
  </div>
</shrd-uic-smartbar>

<ng-template #buttonTpl>
  <button
    class="btn btn-primary position-relative"
    form="headerContactForm"
    shrdUicButton
    variant="primary"
    [disabled]="!isActionEnabled"
  >
    <shrd-uic-preloader [active]="!isActionEnabled" size="small"></shrd-uic-preloader>
    <ng-container *ngTemplateOutlet="labelTpl"></ng-container>
  </button>
</ng-template>

<ng-template #labelTpl>
  <span>{{ actionLabel | i18next }}</span>
</ng-template>
